import { Youtube } from '@cinch-labs/design-system'
import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head, StoryblokRenderer } from '@cinch-nx/landing-ui-shared'
import { Wrapper } from '@cinch-nx/shared-ui'

import styles from './about-us.module.css'
import { GetInTouch } from './components'
import { storyblokComponents } from './data/storyblok-renderer-map'
import type { AboutUsFeatureProps } from './get-static-props'

export function AboutUsFeature({
  story,
  carTotal,
  generatedAt,
  preview,
}: AboutUsFeatureProps) {
  const { content } = useStoryblokState({ story, enableBridge: preview })
  const SEO = content?.SEO?.[0]

  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle="About Us - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
      />
      <article className={styles.root}>
        <Wrapper className={{ container: styles.teaserContainer }} isSlim>
          <div className={styles.teaserContainerInner}>
            <StoryblokRenderer
              block={content.Teaser}
              components={storyblokComponents}
            />
          </div>
        </Wrapper>

        {content.Video?.length > 0 ? (
          <Wrapper isSlim className={{ inner: styles.videoContainer }}>
            <Youtube
              videoId={content.Video[0].videoId}
              title={content.Video[0].title}
              buttonLabel={content.Video[0].buttonLabel}
              className={styles.video}
              customThumbnail={content.Video[0].thumbnail.filename}
              videoUrlOptions={{ autoplay: 1 }}
              showNewPlayIcon
            />
          </Wrapper>
        ) : null}

        <Wrapper isSlim className={{ container: styles.quoteSection }}>
          <StoryblokRenderer
            block={content.TrustPilotQuoteV2}
            components={storyblokComponents}
          />
        </Wrapper>

        <Wrapper
          className={{ container: styles.statsSection }}
          isFluid
          backgroundColor="#ECF5FA"
        >
          <StoryblokRenderer
            block={content.Stats}
            components={storyblokComponents}
            props={{
              carTotal,
              trackingEventName: 'About us - Browse all car clicks',
            }}
          />
        </Wrapper>

        <Wrapper isSlim>
          <StoryblokRenderer
            block={content.Delivery}
            components={storyblokComponents}
          />
        </Wrapper>

        <Wrapper backgroundColor="#F5F5F5">
          <Wrapper
            className={{
              container: styles.partnershipsContainer,
              inner: styles.partnershipsContainerInner,
            }}
            isSlim
          >
            <StoryblokRenderer
              block={content.Partnerships}
              components={storyblokComponents}
            />
          </Wrapper>
        </Wrapper>

        <Wrapper className={{ container: styles.careersContainer }} isSlim>
          <StoryblokRenderer
            block={content.Careers}
            components={storyblokComponents}
          />
        </Wrapper>

        <Wrapper backgroundColor="#F2F5FF">
          <Wrapper
            className={{
              container: styles.constellationContainer,
              inner: styles.constellationContainerInner,
            }}
            isSlim
          >
            <StoryblokRenderer
              block={content.Constellation}
              components={storyblokComponents}
            />
          </Wrapper>
        </Wrapper>

        <Wrapper isSlim>
          <GetInTouch />
        </Wrapper>
      </article>
    </>
  )
}
